import { UserApplicationProperties } from './user-application-properties.model';

const globalRoleSysNames = ['user', 'client', 'admin', 'super_admin'];
const globalRoleEnglishNames = ['User', 'Client', 'Admin', 'Super Admin'];
export enum GlobalRole { User, Client, Admin, SuperAdmin };

export class BaseUser {
  id: number = null;
  email: string = '';
  firstName: string = '';
  lastName: string = '';
  roles: UserApplicationProperties[] = [];
  protected _globalRole: { sysName: string, englishName: string, level: number } = {
                      sysName: '',
                      englishName: '',
                      level: null
                    };

  testID: string = '';

  constructor(json?: any) {
    if (json) {
      this.id = json.id || null;
      this.email = json.email || '';
      this.firstName = json.first_name || '';
      this.lastName = json.last_name || '';
      if (json.global_role) this.setGlobalRole(json.global_role);
    }

    this.generateDynamicId();
  }

  get fullName(): string {
    if (this.firstName && this.lastName) return this.firstName + ' ' + this.lastName;
    return '';
  };

  get globalRole(): any {
    return this._globalRole;
  }

  protected setGlobalRole(jsonRole: string) {
    let level: GlobalRole = globalRoleSysNames.indexOf(jsonRole);
    this.globalRole.level = level;
    this.globalRole.sysName = jsonRole;
    this.globalRole.englishName = globalRoleEnglishNames[level];
  }

  // used for role sort functions, as our filters aren't set up to accept objects
  get globalRoleString(): string {
    return this.globalRole.englishName;
  }

  toJson() {
    console.log(typeof this + ' incorrectly overrides toJson()');
  }

  copy() {
    console.log(typeof this + ' incorrectly overrides copy()');
  }

  generateDynamicId() {
    if (!this.id) this.id = -1; // for tests, as the server shouldn't really return a null ID
    let validId = this.fullName;
    if (validId.length === 0) validId = this.id.toString();
    validId = validId.replace(/\s+/g, '-');
    validId = validId.replace(/[^a-z0-9\-_\.]|^[^a-z0-9]+/gi, '');
    this.testID = 'user-' + validId;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/user/base-user.model.ts